import { createApiClient } from "./client";

const client = createApiClient();

export const report = {
    getParticipantReport: ({ useExamId, userId, assessmentId }: { useExamId: string, userId: string, assessmentId: string }) =>
        client
            .get(
                `/participants/${userId}/surveys/${useExamId}/reports/${assessmentId}`
            )
            .then(({ data }) => data),
};
